import { NAVIGATE_PATH } from "../constants";

export const initialState = {
  toast: {
    duration: 2000,
    open: false,
    severity: 'success',
    message: 'Success',
  },
  formType: {
    create: false,
    update: false,
  },
  isLoading: false,
  serviceLevelType: [],
  serviceLocation: [],
  serviceOfferingAddOn: [],
  shipMethod: [],
  servicePriceLevel: [],
  serviceLevelPriceType: [],
  workOrderType: [],
  serviceResponseType: [],
  gridRadioSelection: null,
  customSelectOption: [10, 25, 50, 100],
  selectOption: [25, 50, 100],
  customRecordCount: 10,
  recordCount: 25,
  gridTableData: [],
  perPageSize: 25,
  alertBoxOpen : false,
  isExpanded: true,
  noteType: [],
  reviewStatus: [],
  caseType: [],
  selectededTab: 0,
  innerSelectededTab: 0,
  innerOosSelectededTab: 0,
  returnUrl: NAVIGATE_PATH.home,
  reRenderModule: 0,
  //Out Of Scope States for Collapsible Panels
  outOfScopeExpandLevel0: true,
  outOfScopeExpandLevel1: true,
  outOfScopeExpandLevel2: true,
  //Out Of Scope Save Alert
  alertBoxSave: false,
  //Archived Out Of Scope States for Collapsible Panels
  outOfScopeExpandLevel3: true,
  outOfScopeExpandLevel4: true,
  outOfScopeExpandLevel5: true,
  userPermissions: null,
  userActivityFulfilled: null,
  userPermissionsNotFound: null,
  contractHistoryTypes: [],
  recordCountGrid: 25,
  pageIndexGrid: 1,
};
